import { IResortShortReport } from 'api/region/types';
import ProjectedOpeningDate from 'components/common/Grid/Cells/ProjectedOpeningDate';
import TitleCell from 'components/common/Grid/Cells/TitleCell';
import ToLodgingRedirectButton from 'components/common/Grid/Cells/ToLodgingRedirectButton';
import { Routes } from 'routes';
import { useOTSTranslation } from 'i18n/useOTSTranslation';

import gridCellStyles from 'components/common/Grid/Cells/styles.module.scss';
import gridStyles from 'components/common/Grid/styles.module.scss';

export const gridColumns = () => {
  const { t } = useOTSTranslation('common');

  return [
    {
      header: {
        className: gridStyles.firstColumn,
        isSortable: true,
        columnName: t('region.liftTickets.resort'),
      },
      dataKey: 'title',
      cellRender: (resort: IResortShortReport) => (
        <TitleCell
          title={resort.title}
          href={Routes.resortSnowReport(resort)}
        />
      ),
    },
    {
      header: { columnName: t('region.openDates.projectedDate'), isSortable: true },
      dataKey: 'opening-date',
      cellRender: ({ status }: IResortShortReport) => <ProjectedOpeningDate status={status} />,
      className: gridStyles.projectedDate,
    },
    {
      header: {
        cellRender: () => (<span>{t('region.openDates.lodging')}</span>),
        className: gridStyles.transparentCell,
      },
      dataKey: 'button_field', // surrogate key, no data needed
      cellRender: (resort: IResortShortReport) => <ToLodgingRedirectButton resort={resort} />,
      className: gridCellStyles.alignEnd,
    },
  ];
};
